var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLotSize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.956 2.667H5.623a2.675 2.675 0 00-2.667 2.666v21.334c0 1.466 1.2 2.666 2.667 2.666h21.333c1.467 0 2.667-1.2 2.667-2.666V5.333c0-1.466-1.2-2.666-2.667-2.666zM5.623 5.333h5.333v13.334H5.623V5.333zm0 21.334v-5.334h5.333v5.334H5.623zm21.333 0H13.623V13.333h13.333v13.334zm0-16H13.623V5.333h13.333v5.334z",
    fill: "#2C5BFF"
  })));
}
export default __webpack_public_path__ + "media/propertyTour/lot-size-f8183457.svg";
export { SvgLotSize as ReactComponent };